import { rj, SUCCESS } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import api from "../api"
import { PAGE_SIZE } from "../consts"

export const UtenteState = rj(
  rjList({
    pagination: nextPreviousPaginationAdapter,
    pageSize: PAGE_SIZE,
  }),
  {
    mutations: {
      removeUtente: {
        effect: (t) => (entity) =>
          api
            .auth(t)
            .mapResponse(() => entity)
            .delete(`/api/utenti/${entity.id}`),
        updater: "deleteItem",
        // Uncomment to make delete optimistic
        // optimistiResult: entity => entity,
      },
      addUtente: {
        effect: (t) => (entity) => api.auth(t).post("/api/utenti", entity),
        updater: "insertItem",
      },
      updateUtente: {
        effect: (t) => (entity) =>
          api.auth(t).put(`/api/utenti/${entity.id}/`, entity),
        updater: "updateItem",
      },
    },
    name: "UtenteState",
    effectCaller: "configured",
    effect: (t) => (params = {}) => api.auth(t).get("/api/utenti", params),
    composeReducer: (prevState, { type, payload }) => {
      if (type === SUCCESS) {
        return {
          ...prevState,
          data: {
            ...prevState.data,
            allCount: payload.data.all_count,
          }
        }
      }
      return prevState
    },
    selectors: ({ getData }) => ({
      getAllCount: state => getData(state)?.allCount ?? null,
    }),
    computed: {
      allCount: "getAllCount",
      pagination: "getPagination",
      list: "getList",
      loading: "isLoading",
    },
  }
)
